// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e3-3";
export var flatBottomCorners = "_e3-5";
export var productImage = "_e3-0";
export var quantityContainer = "_e3-2";
export var quantityHeader = "_e3-6";
export var tooltip = "_e3-1";
export var wrapAndEllipsesOverflow = "_e3-4";